import React, {useState} from 'react'
import {Link} from 'gatsby'
import tw, {styled} from 'twin.macro'
import {motion} from 'framer-motion'
import ColorSwitch from './ColorSwitch'

const Header = tw(
  motion.header
)`fixed antialiased top-0 left-0 z-30 bg-background bg-opacity-50 backdrop-filter backdrop-blur-lg overflow-x-auto  w-full border-b border-gray border-opacity-75 scrollbar-hide
`
const Nav = styled.nav`
  ${tw`flex md:justify-center`}
`

const Social = styled.nav`
  ${tw`flex`}
`
const List = styled.ul`
  ${tw`scrollbar-hide justify-items-center whitespace-nowrap flex justify-between items-center h-12 lg:(w-full max-w-screen-xl px-12) xl:(h-10 grid grid-cols-12 gap-x-3 w-full px-16 max-w-screen-2xl)`}
`
const Item = styled(motion.li)`
  ${tw`inline-block text-gray-lightest object-center transition-colors hover:(underline text-white) mr-8 font-bold text-sm md:text-xs leading-3 first:pl-4 last:pr-4 xl:(first:pl-0 last:pr-0 mr-0)`}
`

const navigation = {
  social: [
    {
      name: 'Facebook',
      styles:
        'text-gray-light hover:text-gray-lightest transition-colors duration-300',
      href: 'http://facebook.com/paulinemaudy',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'Instagram',
      styles:
        'text-gray-light hover:text-gray-lightest transition-colors duration-300',
      href: 'http://instagram.com/paulinemaudy',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: 'Youtube',
      styles:
        'text-gray-light hover:text-gray-lightest transition-colors duration-300',
      href: 'http://youtube.com/paulinemaudy',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
        </svg>
      ),
    },
  ],
}

const FloatMenu = () => {
  return (
    <Header>
      <Nav>
        <List>
          {/* <div tw="text-leaf-light border-r border-opacity-75 pr-8 font-serif font-normal text-lg">
            Home
          </div> */}
          <Item>
            <Link to="/">Home</Link>
          </Item>
          <Item>
            <Link to="/about/">About</Link>
          </Item>
          <Item>
            <Link to="/shows/">Shows</Link>
          </Item>
          <Item>
            <Link to="/project/">Projects</Link>
          </Item>
          <Item>
            <Link to="/workshops-mentoring/">Workshops</Link>
          </Item>

          <Item>
            <Link to="/news/">News</Link>
          </Item>

          <Item>
            <Link to="/contact/">Contact</Link>
          </Item>

          <Item>
            <Link to="#" aria-hidden="true"></Link>
          </Item>
          <Item>
            <Link to="#" aria-hidden="true"></Link>
          </Item>

          {navigation.social.map((item) => (
            <Item>
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                tw="flex text-gray-lightest object-center transition-colors hover:(underline text-white) mr-8 font-bold text-sm md:text-xs first:pl-4 last:pr-4 xl:(first:pl-0 last:pr-0 mr-0)"
              >
                <span tw="sr-only">{item.name}</span>
                <item.icon tw="h-5 w-5" aria-hidden="true" />
              </a>
            </Item>
          ))}
        </List>
      </Nav>
    </Header>
  )
}

export default FloatMenu
